/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { requestPush } from "../../push-notifications/PushNotificationsProvider";

export function RequestPushNotifications() {
  requestPush();
}
